// extracted by mini-css-extract-plugin
module.exports = {"container":"vQ-z","productName":"wQ-z","modal":"xQ-z","dimensions":"yQ-z","recipientEmail":"zQ-z","lowStock":"AQ-z","recommendedFit":"BQ-z","notRecommendedFit":"CQ-z"};